






import { Component, Vue, Watch } from 'vue-property-decorator';
import Postmate from 'postmate';
import $ from 'jquery';
import { Mutation, Action, Getter } from 'vuex-class';
import { IframeParentCommnuicationService } from '@/services/IframeParentCommnuicationService';
import CriteriaEditor from '@/components/CriteriaEditor.vue';
const namespace: string = 'counter';

@Component({
})
export default class App extends Vue {
    private clipped: boolean = true;
    private drawer: boolean = true;
    private miniVariant: boolean = false;
    private right: boolean = true;
    private title: string = 'Audience Builder';
    private iframeParentCommnuicationService = new IframeParentCommnuicationService();
    private config: any = {
        height: () => document.body.clientHeight,
        width: () => '100%',
        abi_update_property_info: this.updatePropertyInfo,
        abi_reposition_elements: this.repositionElements,
        abi_set_parent_domain: this.setAppDomain,
        abi_deselect_audience: this.deselectAudience,
        // abi_open_audience: this.openAudienceDetails
        abi_route: this.routeRequest
    };

    @Getter('currentClientId', { namespace })
    private currentClient!: number;

    @Getter('currentCompanyId', { namespace })
    private currentCompany!: number;

    @Action('updateClientId', { namespace })
    private updateClient: any;

    @Action('updateCompanyId', { namespace })
    private updateCompany: any;

    @Action('updateEnvironmentName', { namespace })
    private updateEnvironment: any;

    constructor() {
        super();
        this.iframeParentCommnuicationService.InitCommunication(this.config);

        this.onElementHeightChange(document.body, () => {
            const data = { action: 'eIn_iframe_height_change', value: document.body.clientHeight, };
            this.iframeParentCommnuicationService.SendMessageToParent(data);
        });
    }

    public mounted() {

        if (this.currentClient === 0) {
            // Standalone ABI component. Initialization will not start
            return;
        }

        // Attempt to inject the client override for local debugging
        // Don't set if the currentClient was already set (>0)

        // Initialize our stores based on the currentClient
        this.$store.dispatch('tag/initializeClient', this.currentClient);
        this.$store.dispatch('property/initializeClient', this.currentClient);

        // Getting the parent eInsight application domain
        this.iframeParentCommnuicationService.SendMessageToParent(
            { action: 'eIn_get_domain' }
        );

        const waitingInitialization = setInterval(() => {
            console.log('waiting ABI initialization');

            if (window.InitializationWatcher.configLoaded
                && window.InitializationWatcher.propertiesLoaded
                && window.InitializationWatcher.tagsLoaded) {

                this.iframeParentCommnuicationService.SendMessageToParent(
                    { action: 'eIn_iframe_init_done' }
                );

                // set up Click event listener on document to close parent eInsight menu dropdown if it's opened
                const self = this;
                $(document).click(() => {
                    self.iframeParentCommnuicationService.SendMessageToParent(
                        { action: 'eIn_Close_Menu_DropDown' }
                    );
                });

                clearInterval(waitingInitialization);
            }
        }, 500);
    }

    @Watch('$route', { immediate: true, deep: true })
    private onUrlChange(newVal: any) {
        const data = { action: 'eIn_route_change', value: newVal.path, };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    // this is the method to handle the event from einsight
    // for changing the clientid and companyid when einsight
    // nav drop down changes
    private updatePropertyInfo(propertyinfo: any): void {
        if (!propertyinfo) {
            return;
        }
        console.log('App.vue => updatePropertyInfo : currentClient', this.currentClient);
        this.updateClient(propertyinfo.clientid);
        this.updateCompany(propertyinfo.companyid);
        this.updateEnvironment(propertyinfo.environmentName);
    }

    // this helps to reposition any UI elements inside ABI iframe,
    // when parent eInsight window scrolls or resizes
    private repositionElements(data: any): void {
        this.repositionModalDialog(data);
        this.repositionCriteriaFilters(data);
    }

    private onElementHeightChange(elm: any, callback: any): any {
        let lastHeight = elm.clientHeight;
        let newHeight = -1;
        (function run() {
            newHeight = elm.clientHeight;
            if (lastHeight !== newHeight) {
                callback();
            }

            lastHeight = newHeight;

            if (elm.onElementHeightChangeTimer) {
                clearTimeout(elm.onElementHeightChangeTimer);
            }

            elm.onElementHeightChangeTimer = setTimeout(run, 200);
        })();
    }

    private repositionModalDialog(parentDimensions: any): void {
        const abiHeight = Math.max(document.body.scrollHeight,
                                    document.body.offsetHeight,
                                    document.documentElement.clientHeight,
                                    document.documentElement.scrollHeight,
                                    document.documentElement.offsetHeight);

        $('div.modal-dialog').css('top', parentDimensions.scrollTop + 300 - abiHeight / 2 + 'px');
    }

    private repositionCriteriaFilters(parentDimensions: any): void {
        // reposition filters list in Criteria Editor
        if (this.$children[0].$children[0]
            && this.$children[0].$children[0].$refs
            && this.$children[0].$children[0].$refs.criteriaEditor) {
            const criteriaEditor = this.$children[0].$children[0].$refs.criteriaEditor as CriteriaEditor;
            parentDimensions.fieldsSectionHeight = $('#fieldsSection').height();
            criteriaEditor.repositionFiltersList(parentDimensions);
        }
    }

    private setAppDomain(data: any): void {
        window.App.$appSettings = data;
        console.log('window.App.$appSettings.eInsightUri: ', window.App.$appSettings.eInsightUri);
        window.InitializationWatcher.configLoaded = true;
    }

    private deselectAudience(): void {
        window.componentSelectedAudience = -1;
        $('input[name="selectAudience"]').prop('checked', false);
    }

    // private openAudienceDetails(data: any): void {
    //    // that.$store.dispatch('manageAudience/setAudienceDetailName',
    //    //    { audienceDetailName: this.attributes['data-detail-name'].value });

    //    let detailType = data.published === true ? 'LastPublished' : 'LastSaved';
    //    this.$router.push(`audience/${data.audienceID}/detail/${detailType}`);
    // }

    private routeRequest(data: any): void {
        console.log('routeRequest: ', data);
        this.$router.push(data.hash);
    }
}
